define(function (require) {
    var $ = require('jquery'),
        avalon = require('avalon'),
        ajax = require('ajax'),
        dialog = require('dialog'),
        pagination = require('pagination'),
        cancleDialog = null,
        receiptDialog = null,
        selectValue,
        tool = require('toolLoaderPC');

    var hiddenValues, list, unwatch;

    var vmodel = avalon.define({
        $id: 'orderListController',
        date: parseInt(new Date().getTime() / 1000),
        data: [],

        // 埋点数据统计
        sendEventTracking: function (n) {
            tool.sendEventTracking('pc', n);
        },

        select: 0,
        filter: {},
        type: 0,
        cancel: function (order) {
            var selectHtml = '';
            for (var i = 0; i < selectValue.length; i++) {
                selectHtml +=
                    '<option value="' + i + '">' + selectValue[i] + '</option>';
            }

            var tmpl = [
                "<div class='d-b-prompt cancel-order-dialog'>",
                "<div class='d-form form-small'>",
                "<p class='label'>请选择取消订单的原因：</p>",
                "<div class='select-wrap'><select class='text-overflow reason'>" +
                    selectHtml +
                    '</select></div>',
                "<p class='label'>请留下你的宝贵建议</p>",
                "<div class='text-wrap'><textarea class='suggest' type='text' class='d-b-prompt-input' placeholder='留下你的宝贵建议'></textarea></div>",
                "<div class='row'><p class='error'></p></div>",
                '</div>',
                "<div class='d-operate'>",
                "<a href='javascript:void(0)' class='btn d-custom-cancel'>取消</a>",
                "<a href='javascript:void(0)' class='btn red d-custom-ok'>确定</a>",
                '</div>',
                '</div>'
            ].join('');

            if (cancleDialog === null || cancleDialog.isDetroyed === true) {
                cancleDialog = dialog.init({
                    width: 500,
                    height: 370,
                    title: '取消订单',
                    onClose: function (dialog, body) {
                        if (
                            typeof dialog.cache.onCancel === 'function' &&
                            dialog.cache.onCancel.call(dialog, dialog, body) ===
                                false
                        ) {

                        }
                    },
                    onInit: function (dialog, body) {
                        body.on('click', '.d-custom-ok', function () {
                            if (
                                typeof dialog.cache.onConfirmOK ===
                                    'function' &&
                                dialog.cache.onConfirmOK.call(
                                    dialog,
                                    dialog,
                                    body
                                ) === false
                            ) {
                                return;
                            }
                            dialog.onlyClose();
                        });
                        body.on('click', '.d-custom-cancel', function () {
                            if (
                                typeof dialog.cache.onConfirmCancel ===
                                    'function' &&
                                dialog.cache.onConfirmCancel.call(
                                    dialog,
                                    dialog,
                                    body
                                ) === false
                            ) {
                                return;
                            }
                            dialog.onlyClose();
                        });
                    }
                });
            }

            cancleDialog.cache.onConfirmOK = function (__dialog, body) {
                var digDom = body.find('.btn.d-custom-ok');
                digDom.addClass('disable');
                ajax
                    .getWithFail('/order_cancel.html', {
                        order_id: order.order_id,
                        reasonKey: body.find('.reason').val(),
                        reason: body.find('.suggest').val()
                    })
                    .done(function (data) {
                        digDom.removeClass('disable');
                        if (data.type == 'succ') {
                            __dialog.close();
                            dialog.alert(data.msg);
                            order.order_status = 5;
                        }
                    })
                    .fail(function () {
                        digDom.removeClass('disable');
                    });
                return false;
            };
            cancleDialog.cache.onConfirmCancel = function (__dialog) {
                __dialog.onlyClose();
            };
            cancleDialog.setHtml(tmpl);
            cancleDialog.open();
        },
        receipt: function (order) {
            var tmpl = [
                '<div class="d-b-confirm"><div class="d-text"><p>请确认你已经收到商品，并且同意支付给商家相应的款项。</p></div><div class="d-operate"><a href="javascript:void(0)" class="btn middle-btn red d-custom-ok">我已收到</a><a href="javascript:void(0)" class="btn middle-btn gray d-custom-cancel">我还没收到</a></div></div>'
            ].join('');

            if (receiptDialog === null || receiptDialog.isDetroyed === true) {
                receiptDialog = dialog.init({
                    width: 420,
                    height: 245,
                    title: '确定收货',
                    onClose: function (dialog, body) {
                        if (
                            typeof dialog.cache.onCancel === 'function' &&
                            dialog.cache.onCancel.call(dialog, dialog, body) ===
                                false
                        ) {

                        }
                    },
                    onInit: function (dialog, body) {
                        body.on('click', '.d-custom-ok', function () {
                            if (
                                typeof dialog.cache.onConfirmOK ===
                                    'function' &&
                                dialog.cache.onConfirmOK.call(
                                    dialog,
                                    dialog,
                                    body
                                ) === false
                            ) {
                                return;
                            }
                            dialog.onlyClose();
                        });
                        body.on('click', '.d-custom-cancel', function () {
                            if (
                                typeof dialog.cache.onConfirmCancel ===
                                    'function' &&
                                dialog.cache.onConfirmCancel.call(
                                    dialog,
                                    dialog,
                                    body
                                ) === false
                            ) {
                                return;
                            }
                            dialog.onlyClose();
                        });
                    }
                });
            }

            receiptDialog.cache.onConfirmOK = function (__dialog, body) {
                var digDom = body.find('.btn.d-custom-ok');
                digDom.addClass('disable');
                ajax.getWithFail(
                    '/order_confirm.html',
                    {
                        order_id: order.order_id
                    },
                    function (data) {
                        digDom.removeClass('disable');
                        if (data.type == 'succ') {
                            __dialog.close();
                            dialog.alert('确认收货成功！');
                            order.order_status = 4;
                        }
                    }
                );
                return false;
            };
            receiptDialog.cache.onConfirmCancel = function (__dialog) {
                __dialog.onlyClose();
            };
            receiptDialog.setHtml(tmpl);
            receiptDialog.open();
        },
        consultPagination: pagination.init(0, 0, 0),
        consultGoPage: function (page) {
            if (page.disable) {
                return;
            }
            ajax.pjax('?page=' + page.target + '&type=' + vmodel.select);
        }
    });

    window.avalon = avalon;

    return {
        init: function () {
            hiddenValues = tool.getHiddenValues('#js-local-hiddens');
            selectValue = hiddenValues.cancel_reason.order_reason;
            list = hiddenValues.order_list;

            vmodel.data = list.order_list;
            vmodel.filter = list.filter.types;
            vmodel.select = list.filter.type;
            vmodel.consultPagination = pagination.init(
                list.page_list.total_count,
                list.page_list.page,
                list.page_list.page_size
            );
            unwatch = vmodel.$watch('select', function () {
                ajax.pjax('?type=' + vmodel.select);
            });

            setTimeout(function () {
                $('#pjax-container .personal-aside').css('height', 'auto');
                tool.fixHeight(
                    $('#pjax-container .container'),
                    $('#pjax-container .personal-aside')
                );
            }, 0);
            vmodel.sendEventTracking(10700);
            // 进入购物车统计
            $('.go-to-cart').click(function () {
                vmodel.sendEventTracking(10500);
            });
        },
        clear: function () {
            unwatch();
        }
    };
});



// WEBPACK FOOTER //
// ./src/js_modules/orderListController.js